"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dateFns = require("date-fns");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var listeners = {};
var counter = 0;
var intervalId;
var createInterval = function createInterval() {
  if (!intervalId) {
    intervalId = setInterval(function () {
      return Object.values(listeners).forEach(function (listener) {
        return listener();
      });
    }, 60 * 1000);
  }
};
var register = function register(callback) {
  createInterval();
  var myCounter = counter++;
  listeners[myCounter] = callback;
  return function () {
    if (listeners[myCounter]) {
      delete listeners[myCounter];
    }
  };
};

/**
 * Provides a time string relative to now that updates every 60 seconds
 * @param {string} time - date string
 */
var useRelativeTime = function useRelativeTime(time) {
  var _useState = (0, _react.useState)(""),
    formatStr = _useState[0],
    setFormatStr = _useState[1];
  (0, _react.useEffect)(function () {
    var deregister;
    if (!!time) {
      var rDate = new Date(time);
      if (isNaN(rDate)) return;
      var fn = function fn() {
        return setFormatStr((0, _dateFns.intlFormatDistance)(rDate, new Date()));
      };
      fn();
      deregister = register(fn);
    }
    return function () {
      return deregister && deregister();
    };
  }, [time]);
  return formatStr;
};
var _default = exports["default"] = useRelativeTime;